import React from 'react';
import { Button, Modal } from 'react-bootstrap';

const TermsOfService = ({ show, onHide }) => {



  return (
    <Modal show={show} onHide={onHide} size="xl">
      <Modal.Header closeButton>
        <Modal.Title>TERMS OF SERVICE</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <div className="policyPage">
          <section className="tnc-page section-b-space" style={{ padding: 30 }}>
            <div className="container">
              <div className="bg-white" style={{ padding: '30px' }}>
                <div className="d-flex justify-content-between">
                  <h2>TERMS OF SERVICE</h2>
                </div>
                <div>
                  <hr size="0" width="100%" align="center" />
                </div>
                <p>
                  These Standard Terms of Service shall manage your use/ subscribe of the
                  https://a2p.elfo.com/ platform (“Sites”), as subscribers of our portals administered and
                  managed by Elfo Sdn Bhd (“Elfo”, “we,” or “us”).
                  <br />
                  elfoA2P is bulk SMS text messaging facilities for marketing purposes including
                  notification, promotion and updates (“Services”). By using the Services or accessing any
                  content or material that is made available on the Sites or its subscribers through the
                  Services you understand and agree to accept and adhere to the following terms and
                  conditions as stated herein. If you're using the Services for an entity, you're agreeing
                  to this Agreement on behalf of that entity, and you represent and warrant that you can
                  do so.
                  <br />
                  Please read the following Terms of Service carefully as they contain important
                  information about the Services provided to you and any fees and charges applicable to
                  the Services. You acknowledge that you have read and understood the Terms of Service,
                  accept these Terms of Service, and agree to be bound by them. If you don’t agree with
                  (or cannot comply with) the Terms of Service or to be bound by them, then you will not
                  been granted the required authorization to access and use the Services including without
                  limitation, any of the various products and other content materials or related services
                  offered by Elfo and its affiliates.
                  <br />
                  The Terms of Service is a contract between you and Elfo and any special conditions
                  negotiated between Elfo and you shall prevail over these Standard Terms of Service. By
                  clicking “[**]” box, you acknowledge and confirm that you have reached the legal age of
                  majority and expressly indicate that you accept and agree to comply with all of the
                  terms and conditions set forth of the Agreement.
                </p>
                <h3>Changes to the Agreements</h3>
                <p>
                  We reserve the right to change the Terms of Service from time to time along with the
                  Services without notice. You acknowledge and agree that it is your responsibility to
                  review the Terms of Service periodically to familiarize yourself with any modifications.
                  In the event of material changes to the Terms of Service, we will notify you at least 14
                  days before these new Terms of Service apply to you, by issuing notice accessible
                  through your use of the Services or by email to your registered email account. Please
                  therefore make sure you read any such notice carefully. Your continued use of the
                  Services after such modifications will constitute acknowledgment and agreement of the
                  modified Terms of Service. If you don’t agree with the new Terms of Service, you are
                  free to reject the Terms of Service by contacting us at [**]; unfortunately, that means
                  you will no longer be able to use the Services.
                </p>
                <h3>Account</h3>
                <p>
                  The Services may begin with creation an account for the Services (“Account”). When
                  creating or updating the Account, you are required to provide us with accurate, complete
                  and up to-date information which may include your name, email address, payment
                  information, products or services contents and other personal data. You are solely
                  responsible for maintaining the confidentiality of login details and all activities that
                  occur within your Account. By creating the Account, you agree to be contacted by us and
                  receive marketing or promotional material and other information we may send. Without
                  limiting any other remedies, we reserve the right, in our sole discretion, to restrict,
                  suspend or terminate your Account and/or your access to all or all parts of the Services
                  at any time, for any reason whatsoever or Elfo suspects that you are failing to comply
                  with the Terms of Service or for any actual or suspected illegal or improper use of the
                  Services, with or without prior notice, and without liability. We are under no
                  obligation to compensate you for any losses or results related to this.
                </p>
                <h3>Contents</h3>
                <p>
                  The Services is based on your contributing and posting content to the Service, including
                  without limitation graphics, pictures, videos, text, data, messages, information, goods/
                  products and any other material content (“Your Content”). We do not control Your Content
                  posted via the Service and, as such, does not guarantee the accuracy, integrity or
                  quality of such Content. Under no circumstances we will be liable in any way for any
                  Content, including, but not limited to, for any errors or omissions in any Content, or
                  for any loss or damage of any kind incurred as a result of the use of any Content
                  posted, emailed, transmitted or otherwise made available via the Services. We may
                  pre-screen, review, monitor, edit or remove Your Content in our sole discretion, but is
                  under no obligation to do so. In all cases, we reserve the right to remove or disable
                  access to any Your Content for any or no reason, including but not limited to, Your
                  Content that, in our sole discretion, violates the Terms of Service. Removal or
                  disabling of access to Your Content shall be at our sole discretion. You are solely
                  responsible for all Your Content that have published, uploaded, posted, transmitted or
                  otherwise make available via the Services. We do not endorse the correctness of Your
                  Content or obtain consent or any opinion contained in any Your Content. You will, to the
                  greatest possible extent permissible under applicable law, indemnify and hold us and our
                  third-party rights or applicable laws, regulations or legal requirements anywhere in the
                  world, including any loss, costs and expenses arising out of such third party claim.
                </p>
                <h3>Fees & Payment</h3>
                <p>
                  The Services are pre-paid services and post-paid Services. By using the Services, you
                  agree to pay all fees, as determined by us at our sole discretion. The Services require
                  payment before you can access and use of the Services. The prices displayed on the Sites
                  are exclusive of all taxes, levies or duties imposed by taxing authorities and you shall
                  be responsible for payment of all such taxes, levies or duties. By using the Services,
                  you agree to pay us, through our third-party payment all charges at the process then in
                  effect for any use of such Service in accordance with the applicable payment terms. We
                  reserve the right to correct any errors or mistakes that it makes even if it has already
                  requested or received payment. We recommend that you review the terms of use and privacy
                  policy of such third parties before submitting any personal data and using such third
                  party’s applications. Once a payment has been made for use of the Services, there will
                  be no refunds or credits for partial use of the Services or early termination or
                  cancellation of the Services or other charges that are unauthorized. For such
                  termination or cancellation of the Services by you, we do not prorate and the Services
                  may cause the loss features of the Services for your Account. You may contact us for
                  termination or cancellation of the Services or any changes to your Account via email to
                  [**]. Pricing of all Services, including but not limited to fees for the Services and
                  add-on charges, if any, are subject to change. Such notice may be provided by posting on
                  the Sites and/or sending you a notification by email.
                </p>
                <h3>Use of the Services</h3>
                <p>
                  By creating an Account and subscribe to the Services, you agree to comply with the Terms
                  of the Service, Privacy Policy or any policy posted on the Sites and use the Services
                  only for lawful purpose. Any use of the Services contrary to the applicable laws and
                  violation of the rights of third parties is prohibited. You may not submit or transmit
                  through the Service any information, content, or material or otherwise engage in any
                  conduct that: -
                  <ul>
                    <li>
                      violates or infringes the rights of others, including, without limitation, patent,
                      trademark, trade secret, copyright, publicity, or other proprietary rights;
                    </li>
                    <li>
                      is unlawful, threatening, abusive, harassing, defamatory, libellous, deceptive,
                      fraudulent, invasive of another’s privacy, tortuous, contains explicit or graphic
                      descriptions or accounts of sexual acts, or is pornographic, illegal contests or
                      gambling, unsolicited or unauthorized advertising, promotional materials, “junk
                      mail,” “spam,” “chain letters,” “pyramid schemes,” or any other form of
                      solicitation;
                    </li>
                    <li>
                      victimizes, harasses, degrades, or intimidates an individual or group of individuals
                      on the basis of religion, gender, sexual orientation, race, ethnicity, age, or
                      disability;
                    </li>
                    <li>
                      impersonates any person, business, or entity, including Elfo and its employees and
                      agents;
                    </li>
                    <li>
                      contains viruses or any other computer code, files, or programs that interrupt,
                      destroy, or limit the functionality of any software or hardware or
                      telecommunications equipment, or that otherwise permit the unauthorized use of a
                      computer or computer network; or
                    </li>
                    <li>
                      encourages conduct that would constitute a criminal offense or give rise to civil
                      liability.
                    </li>
                  </ul>
                  <br />
                  We reserve the right to determine what conduct it considers to be in violation of the
                  Terms of Service or otherwise outside the intent or spirit of these Terms of Service. We
                  reserve the right to take action as a result, which may include suspending or
                  terminating the Services and your Account and prohibiting you from using the Services in
                  whole or in part.
                </p>
                <h3>Third Party Applications</h3>
                <p>
                  The Services is integrated with third party applications, websites, and services (“Third
                  Party Applications”) to make available content, products, and/or services to you. These
                  Third-Party Applications may have their own terms and conditions of use and privacy
                  policies and your use of these Third-Party Applications will be governed by and subject
                  to such terms and conditions and privacy policies. You understand and agree that we do
                  not endorse and is not responsible or liable for the behaviour, features, or content of
                  any Third-Party Application or for any transaction you may enter into with the provider
                  of any such Third Party Applications.
                </p>
                <h3>Proprietary Rights</h3>
                <p>
                  All materials contained on the Services including all content, marks, data, works,
                  software, graphics, text, layouts, information, music, video, images, scripts, designs,
                  button icons, instructions, illustrations, logo, trademarks, look and feel of the Sites
                  and all other intellectual property rights related thereto (“Proprietary Materials”) are
                  owned or controlled by Elfo or affiliated companies, our third party licensors. Except
                  with our consent, you shall not use the Proprietary Materials, in any way whatsoever,
                  other than those provided for herein.
                </p>
                <h3>Personal Data of Third Parties</h3>
                <p>
                  For the purpose of providing the Services, we have access to all information (including
                  but not limited to third party personal data and contents of messages) contained in
                  distribution list created by you in your Account. You are responsible for the processing
                  and transmission of third party’s personal data in with applicable laws in force in your
                  country of residence and you guarantee that the your distribution list have granted you
                  express consent to send them messages of the type that you intend to send them.
                  <br />
                  You are responsible for processing the personal data (excluding sensitive data)
                  contained in your distribution list and your use of such personal data shall comply with
                  all applicable laws and regulations such as Personal Data Protection Act 2010, Malaysia.
                  If you: -
                  <ul>
                    <li>have an establishment in the European Economic Area (the “EEA”), or</li>
                    <li>
                      offer goods or services to data subjects in the EEA, irrespective of whether a
                      payment is required, or
                    </li>
                    <li>monitor behaviour of data subjects in the EEA,</li>
                  </ul>
                  <br />
                  you represent and warrant that in using the Service, in particular in creating
                  distribution list, sending messages and collecting personal data, you comply with all
                  personal data protection, privacy, and electronic communication regulations applicable
                  in the EEA and its member states. In particular:-
                  <ul>
                    <li>
                      that the personal data contained in the files transmitted have been collected and
                      processed in compliance with the applicable regulations;
                    </li>
                    <li>
                      that the personal data contained in the files transmitted have been collected and
                      processed in compliance with the applicable regulations;
                    </li>
                    <li>
                      that you have informed the data subjects in accordance with the applicable rules;
                    </li>
                    <li>
                      where appropriate, that the collection and processing have been consented to by the
                      data subjects;
                    </li>
                    <li>
                      where appropriate, that the collection and processing have been consented to by the
                      data subjects;
                    </li>
                    <li>
                      that the data subjects shall be allowed to exercise their rights in accordance with
                      the applicable rules;
                    </li>
                    <li>
                      that you undertake that the information will be rectified, completed, clarified,
                      updated or deleted if it is inaccurate, incomplete, ambiguous if the data subject
                      wishes to prohibit its collection, use, communication or storage.
                    </li>
                  </ul>
                  <br />
                  It is specified that you are solely responsible for managing the retention periods of
                  personal data that they upload onto the Sites, and that it is incumbent on them to
                  delete the data as and when its retention period expires. We shall be responsible only
                  for deleting this data at the end of your contractual relationship.
                  <br />
                  In the event of a violation of this clause, you shall be solely responsible for any
                  consequences, and undertakes to guarantee, and if necessary, indemnify, us or affiliated
                  companies or our third-party licensors.
                </p>
                <h3>Copyrights</h3>
                <p>
                  If you believe in good faith that material available in the Service infringes your
                  copyright and/or if you believe in good faith that someone has wrongly filed a notice of
                  copyright infringement against you, you (or your agent) may send to us a written notice
                  by mail or e-mail to [**], requesting us to removes such material or blocks access to
                  it.
                  <br />
                  Please note that we may, in appropriate circumstances, terminate or suspend users and
                  accountholders who are repeat infringers. Notwithstanding the foregoing, we may in its
                  sole discretion take such actions as it deems fit in order to protect the intellectual
                  property rights of any intellectual property owner, including but not limited to
                  removing Your Content.
                </p>
                {/* New para */}
                <h3>Privacy</h3>
                <p>
                  Your privacy is important to us, the Terms of the Service also incorporates, by this
                  reference, our Privacy Policy, which explains how we collect and use your content and
                  information. Please read the Privacy Policy.
                </p>
                {/* New para */}
                <h3>Warranty and Disclaimer</h3>
                <p>
                  Although we will endeavour to provide the Services in the best possible way without
                  interruptions, you understand and agree that the Services is provided “as is” and “as
                  available”, without any express or implied warranty, condition or assurance of any kind.
                  This means that we do not represent or warrant to you that:
                  <ul>
                    <li>the use of the Services will meet your needs or requirements;</li>
                    <li>
                      the use of the Services will be uninterrupted, timely, secure or free from errors;
                    </li>
                    <li>
                      the information obtained by using the Services will be accurate or reliable; or
                    </li>
                    <li>
                      any defects in the operation or functionality of the Services we provide will be
                      repaired or corrected.
                    </li>
                  </ul>
                  <br />
                  You are using the Services at your own risk and for a variety of reasons. This section
                  shall apply to the greatest possible extent permitted under applicable law.
                </p>
                {/* New para */}
                <h3>Limitation</h3>
                <p>
                  To the fullest extent allowed by applicable law, under no circumstances (including
                  without limitation, tort, contract, strict liability or otherwise) shall we (or our
                  licensors or suppliers) be liable to you or to any other person for (1) any indirect,
                  special, incidental, punitive, exemplary, or consequential damages; or (2) any loss of
                  use, data, business, or profits (whether direct or indirect), in all cases arising out
                  of the use or inability to use the Services, third party applications, or third party
                  application content, regardless of legal theory, without regard to whether we have been
                  made aware of the possibility of those damages, and even if a remedy fails of its
                  essential purpose; or (3) aggregate liability for all claims relating to the Services or
                  third party applications shall not exceed the equivalent of amount paid for the Service
                  for a month period or 30 days immediately preceding date when the event causing such
                  claim occurred, with the exclusion of any add-on fees and additional charges; or (4) any
                  matter beyond our reasonable control.
                </p>
                {/* New para */}
                <h3>Indemnification</h3>
                <p>
                  Upon a request by us, you agree to defend, indemnify, and hold harmless us and our
                  parent and other affiliated companies as well as any respective employees, contractors,
                  officers, directors, and agents from all liabilities, claims, and expenses, including
                  legal fees that arise from your use or misuse of the Service. We reserve the right, at
                  our own expense, to assume the exclusive defence and control of any matter otherwise
                  subject to indemnification by you, in which event you will cooperate with us in
                  asserting any available defences.
                </p>
                {/* New para */}
                <h3>Severability and waiver</h3>
                <p>
                  Unless as otherwise stated in the Terms of the Service, should any provision of the
                  Terms of the Service be held invalid or unenforceable for any reason or to any extent,
                  such invalidity or enforceability shall not in any manner affect or render invalid or
                  unenforceable the remaining provisions of the Terms of the Service, and the application
                  of that provision shall be enforced to the extent permitted by law.
                  <br />
                  Any failure by us or any third-party beneficiary to enforce the Terms of the Service or
                  any provision thereof shall not waive our or the applicable third-party beneficiary’s
                  right to do so.
                </p>
                {/* New para */}
                <h3>Assignment</h3>
                <p>
                  We may assign and delegate any of our rights and obligations under the Terms of the
                  Service to any individual or entity at our discretion. You may not assign the Terms of
                  the Service or any part of them, nor transfer or sub-license your rights under the Terms
                  of the Service, to any third party.
                </p>
                {/* New para */}
                <h3>Governing Law / Jurisdiction</h3>
                <p>
                  The Terms of the Service are governed by and will be construed under the laws of
                  Malaysia, without regard to the conflicts of law’s provisions thereof. Furthermore, any
                  action to enforce the Terms of the Service shall be brought in the courts located in
                  Malaysia. You hereby agree to the jurisdiction by such courts, and waive any
                  jurisdictional, venue, or inconvenient forum objections to such courts.
                </p>
                {/* New para */}
                <h3>Miscellaneous</h3>
                <p>
                  You agree that the Terms of the Service and any additional terms are the complete and
                  exclusive statement of the mutual understanding between you and us, and it supersedes
                  and cancels all previous written and oral agreements, communications and other
                  understandings relating to the subject matter of the Terms of the Service.
                </p>
              </div>
            </div>
          </section>
        </div>
      </Modal.Body>
      <Modal.Footer>
        <Button variant="secondary" onClick={onHide}>
          Close
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default TermsOfService;